import Link from 'next/link'
import { useRouter } from 'next/router'

import * as S from './styles'
import { Button } from '../button'
import { Text } from '../text'
import { ArrowLeftIcon, ArrowRightIcon } from '@/assets/icons'

export type CasePaginationProps = {
  /**
   * Length of content to be paginated
   * @example
   * ```tsx
   * <casePagination length={10} />
   * ```
   * */
  length: number

  /**
   * Function to handle index changes
   * @example
   * ```tsx
   * <casePagination setIndex={handleIndexChange} />
   * ```
   * */
  setIndex: (index: number) => void

  /**
   * Current index of pagination
   * @example
   * ```tsx
   * <casePagination index={1} />
   * ```
   * */
  index: number
  slug: string
  className?: string
}

export const CasePagination: React.FC<CasePaginationProps> = ({
  length,
  setIndex,
  index,
  slug,
  className,
}) => {
  const turnNextPage = () => {
    if (index + 1 !== length) {
      setIndex(index + 1)
      return
    }
    setIndex(0)
  }

  const turnPreviousPage = () => {
    if (index > 0) {
      setIndex(index - 1)
      return
    }
    setIndex(length - 1)
  }

  const router = useRouter()

  return (
    <S.InteractiveContainer className={className}>
      <div className="page-turner">
        <button
          type="button"
          onClick={turnPreviousPage}
          className="image-button"
        >
          <S.ArrowImage
            width={0}
            height={0}
            src={ArrowLeftIcon}
            alt="arrow"
            className="arrow-back"
          />
        </button>

        <Text size="b3" className="page-counter">{`${
          index + 1
        }/${length}`}</Text>

        <button type="button" onClick={turnNextPage} className="image-button">
          <S.ArrowImage
            width={0}
            height={0}
            src={ArrowRightIcon}
            alt="arrow"
            className="arrow-next"
            onClick={turnNextPage}
          />
        </button>
      </div>

      {router.locale === 'pt-BR' && (
        <div className="info-button">
          <Link href={`/case/${slug}`} passHref>
            <Button>Conheça o case</Button>
          </Link>
        </div>
      )}
    </S.InteractiveContainer>
  )
}
